import React from "react";

/**
 * The wait, wherever the app has to make one.
 *
 * Every page used to spell this out itself - a bare spinner over a line of
 * grey text, in a card the width of the screen - so each one drifted a little
 * from the last. One component means one answer to "what does Hostor look
 * like while it is thinking", and a page says what it is fetching rather than
 * how to draw a wait.
 *
 * It announces itself to a screen reader as a status, so the wait is heard
 * rather than only seen.
 *
 * @param title what is being loaded, as a sentence
 * @param detail an optional second line, for a wait worth explaining
 * @param inline true inside a panel that already has its own card and border
 */
export default function LoadingState({ title = "Loading…", detail, inline }) {
  return (
    <div
      className={`load-state${inline ? " load-state--inline" : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className="load-state__mark" aria-hidden="true">
        <span className="load-state__ring" />
        <img src="/assets/logo.svg" alt="" />
      </span>

      <p className="load-state__title">{title}</p>
      {detail && <p className="load-state__detail">{detail}</p>}

      {/* Three bars where the content will be. They carry no information -
          they are there so the wait has the shape of the page arriving,
          rather than a spinner in an empty box. */}
      <span className="load-state__bars" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
    </div>
  );
}
